import fetch, { fetchConfig } from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchMetrics: ({ entities }, readStatus, config = fetchConfig()) => fetch.useFetchDispatch(
    actions.FETCH_METRICS,
    readStatus,
    { entities },
    config,
  ),
};
